var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_34755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7051 14.9834L14.7251 38.9804H20.7851L20.7751 14.9736L14.7051 14.9834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3848 33.4971L24.3948 39.0191H38.6248L38.6148 33.4873L24.3848 33.4971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5046 29.943L30.4946 24L24.4346 24.0098L24.4446 29.943H30.5046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3848 14.9444L24.3948 20.4663H38.6248L38.6148 14.9346L24.3848 14.9444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5146 6.48478H27.3346C25.9446 6.48478 24.5446 6.16168 23.3046 5.55466L13.8246 0.923654C13.4146 0.72784 12.9446 0.610352 12.4846 0.610352H6.47461C3.16461 0.610352 0.474609 3.24405 0.474609 6.49457V38.5689C0.474609 40.6152 1.18461 42.495 2.38461 43.993C2.38461 43.993 4.29461 47.2141 7.66461 47.2141C8.25461 47.3316 8.86461 47.4001 9.48461 47.4001H20.4746H42.5146C43.1346 47.4001 43.7446 47.3414 44.3346 47.2141C47.7046 47.2141 49.6146 43.993 49.6146 43.993C50.8046 42.495 51.5246 40.6152 51.5246 38.5689V15.3062C51.5246 10.4402 47.4846 6.48478 42.5146 6.48478ZM21.9946 38.9899C21.9946 39.6361 21.4546 40.1648 20.7846 40.1648H14.7046C14.0446 40.1648 13.4946 39.6361 13.4946 38.9899V14.9733C13.4946 14.3173 14.0346 13.7886 14.7046 13.7886H20.7846C21.4546 13.7886 21.9946 14.3173 21.9946 14.9733V38.9899ZM23.2246 24.0004C23.2246 23.3444 23.7646 22.8157 24.4346 22.8157H30.5146C31.1846 22.8157 31.7246 23.3444 31.7246 24.0004V29.9531C31.7246 30.5993 31.1846 31.128 30.5146 31.128H24.4346C23.7646 31.128 23.2246 30.5993 23.2246 29.9531V24.0004ZM39.7446 39.0291C39.7446 39.6361 39.2446 40.1256 38.6246 40.1256H24.3946C23.7746 40.1256 23.2746 39.6361 23.2746 39.0291V33.4875C23.2746 32.8805 23.7746 32.391 24.3946 32.391H38.6246C39.2446 32.391 39.7446 32.8805 39.7446 33.4875V39.0291ZM39.7446 20.4757C39.7446 21.0827 39.2446 21.5723 38.6246 21.5723H24.3946C23.7746 21.5723 23.2746 21.0827 23.2746 20.4757V14.9342C23.2746 14.3271 23.7746 13.8376 24.3946 13.8376H38.6246C39.2446 13.8376 39.7446 14.3271 39.7446 14.9342V20.4757Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_34755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.05,
    height: 46.78,
    fill: "white",
    transform: "translate(0.474609 0.610352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d76fb8c1d381fb0dd8cc5d3822e87ddb.svg";
export { ForwardRef as ReactComponent };